import Vue from 'vue';
import Router from 'vue-router';

/* eslint-disable indent */
const Upgrades     = resolve => require(['../components/UpgradeList.vue'], resolve),
      Home         = resolve => require(['../components/Home.vue'], resolve),
      Shops        = resolve => require(['../components/ShopList.vue'], resolve),
      Achievements = resolve => require(['../components/AchievementList.vue'], resolve),
      Login        = resolve => require(['../components/Login.vue'], resolve),
      Signup       = resolve => require(['../components/Signup.vue'], resolve),
      Settings     = resolve => require(['../components/Settings.vue'], resolve),
      Managers     = resolve => require(['../components/ManagerList.vue'], resolve);

Vue.use(Router);

export default new Router({
    mode:   'history',
    routes: [
        {
            path:      '/',
            name:      'Home',
            component: Home
        },
        {
            path:      '/shops',
            name:      'Shops',
            component: Shops
        },
        {
            path:      '/managers',
            name:      'Managers',
            component: Managers
        },
        {
            path:      '/achievements',
            name:      'Achievements',
            component: Achievements
        },
        {
            path:      '/upgrades',
            name:      'Upgrades',
            component: Upgrades
        },
        {
            path:      '/login',
            name:      'Login',
            component: Login
        },
        {
            path:      '/settings',
            name:      'Settings',
            component: Settings
        },
        {
            path:      '/signup',
            name:      'Signup',
            component: Signup,
            alias:     '/register'
        }
    ]
});
